import { useQuery } from "@tanstack/react-query"
import { getEmpresaGestionadaAsesoriaInvitacion } from "api/EmpresaGestionadaAsesoria.service"

export function useAsesoriasInvitaciones(verificada: boolean) {
  const {
    data: asesoriasInvitaciones,
    isLoading: asesoriasInvitacionesIsLoading,
    error: asesoriasInvitacionesError,
    refetch: asesoriasInvitacionesRefetch,
  } = useQuery({
    queryKey: ["empresaGestionadaAsesoriaInvitacion"],
    queryFn: () => getEmpresaGestionadaAsesoriaInvitacion(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 20,
    retry: false,
    enabled: verificada,
  })

  return {
    asesoriasInvitaciones,
    asesoriasInvitacionesIsLoading,
    asesoriasInvitacionesError,
    asesoriasInvitacionesRefetch,
  }
}
